import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { ToastModule } from '@libs/src/toast/toast.module';
import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';
import { DialogConfirmPromptModule } from '@main-client/src/app/dialog-confirm-prompt/dialog-confirm-prompt.module';
import { DialogModule } from '@main-client/src/app/dialog/dialog.module';
import { FormModule } from '@main-client/src/app/form/form.module';
import { ProgressSpinnerModule } from '@main-client/src/app/progress-spinner/progress-spinner.module';
import { DialogSessionSettingsModule } from '@main-client/src/app/settings/dialog-sessions-settings/dialog-session-settings.module';
import { SettingsPersonalEmailChangeModule } from '@main-client/src/app/settings/settings-personal/settings-personal-email-change/settings-personal-email-change.module';
import { SettingsScreenRecordingModule } from '@main-client/src/app/settings/settings-screen-recording/settings-screen-recording.module';

import { AccountBackend } from '@libs/src/account/account.backend';
import { AuthGuardService } from '@main-client/src/app/core/auth-guard.service';
import { SettingsFormBuilderService } from '@main-client/src/app/settings/settings-form-builder.service';

import { SettingsPersonalComponent } from '@main-client/src/app/settings/settings-personal/settings-personal.component';

@NgModule({
  declarations: [SettingsPersonalComponent],
  exports: [SettingsPersonalComponent],
  imports: [
    CommonModule,
    DialogConfirmPromptModule,
    DialogModule,
    DialogSessionSettingsModule,
    FlexLayoutModule,
    FormModule,
    MatButtonModule,
    MatDialogModule,
    MatExpansionModule,
    RouterModule.forChild([
      {
        canActivate: [AuthGuardService],
        component: SettingsPersonalComponent,
        path: '',
      },
    ]),
    MatIconModule,
    MatSelectModule,
    ProgressSpinnerModule,
    SettingsPersonalEmailChangeModule,
    SettingsScreenRecordingModule,
    ToastModule,
    TtcMatInputModule,
  ],
  providers: [AccountBackend, SettingsFormBuilderService],
})
export class SettingsPersonalModule {}
